import { render, staticRenderFns } from "./ComparadorFolio.vue?vue&type=template&id=428d71be&scoped=true"
import script from "./ComparadorFolio.vue?vue&type=script&lang=js"
export * from "./ComparadorFolio.vue?vue&type=script&lang=js"
import style0 from "./ComparadorFolio.vue?vue&type=style&index=0&id=428d71be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d71be",
  null
  
)

export default component.exports